import React from "react";

export const Header = ({ color, children }) => (
  <h1
    className="sub-header"
    style={{
      color,
    }}
  >
    {children}
  </h1>
);
